// src/constants/product-categories.ts
export const PRODUCT_CATEGORIES = [
    {
      key: 'SOINS_HYGIENE_CORPORELLE',
      label: 'Soins et hygiène corporelle',
      icon: '🧴',
      subcategories: [
        'Gels douche, savons, crèmes hydratantes',
        'Déodorants, lotions pour le corps',
        'Soins des mains, pieds, ongles',
        'Produits pour peaux sensibles / atopiques'
      ]
    },
    {
      key: 'HYGIENE_BUCCO_DENTAIRE',
      label: 'Hygiène bucco-dentaire',
      icon: '🧼',
      subcategories: [
        'Dentifrices, brosses à dents',
        'Bain de bouche, fil dentaire',
        'Soins pour dents sensibles, blanchiment'
      ]
    },
    {
      key: 'SOINS_VISAGE_DERMOCOSMETIQUE',
      label: 'Soins du visage / dermocosmétique',
      icon: '🧴',
      subcategories: [
        'Crèmes anti-âge, anti-taches',
        'Sérums, lotions, masques',
        'Démaquillants, nettoyants, toniques',
        'Produits pour peaux grasses / acnéiques'
      ]
    },
    {
      key: 'PRODUITS_SOLAIRES',
      label: 'Produits solaires',
      icon: '☀️',
      subcategories: [
        'Crèmes solaires, sprays UV',
        'Après-soleil, autobronzants'
      ]
    },
    {
      key: 'PRODUITS_BEBE_MATERNITE',
      label: 'Produits pour bébé et maternité',
      icon: '👶',
      subcategories: [
        'Liniment, couches, crèmes pour le change',
        'Soins pour la peau, eau nettoyante',
        'Tétines, biberons, tire-lait',
        'Compléments pour la grossesse/allaitement'
      ]
    },
    {
      key: 'SOINS_CAPILLAIRES',
      label: 'Soins capillaires',
      icon: '💇‍♀️',
      subcategories: [
        'Shampoings, après-shampoings',
        'Lotions antichute, soins cuir chevelu',
        'Produits antipelliculaires'
      ]
    },
    {
      key: 'COMPLEMENTS_ALIMENTAIRES_NUTRITION',
      label: 'Compléments alimentaires / nutrition',
      icon: '💊',
      subcategories: [
        'Vitamines, minéraux, probiotiques',
        'Produits minceur, détox, digestion',
        'Compléments pour les articulations, le sommeil, l\'immunité'
      ]
    },
    {
      key: 'BIEN_ETRE_SANTE_NATURELLE',
      label: 'Bien-être et santé naturelle',
      icon: '🧠',
      subcategories: [
        'Huiles essentielles, aromathérapie',
        'Fleurs de Bach, phytothérapie',
        'Baumes naturels, cataplasmes'
      ]
    },
    {
      key: 'HYGIENE_INTIME_PROTECTIONS',
      label: 'Hygiène intime et protections',
      icon: '🧻',
      subcategories: [
        'Gels intimes, lingettes, soins gynécologiques',
        'Serviettes, tampons, culottes menstruelles',
        'Préservatifs, lubrifiants'
      ]
    },
    {
      key: 'MATERIEL_MEDICAL_PREMIERS_SOINS',
      label: 'Matériel médical léger / premiers soins',
      icon: '🚑',
      subcategories: [
        'Pansements, désinfectants, compresses',
        'Thermomètres, tensiomètres',
        'Gels anti-douleur, orthèses'
      ]
    },
    {
      key: 'HYGIENE_DESINFECTION',
      label: 'Hygiène et désinfection',
      icon: '🧼',
      subcategories: [
        'Gels hydroalcooliques',
        'Savons antibactériens',
        'Lingettes désinfectantes'
      ]
    },
    {
      key: 'COSMETIQUE_MAQUILLAGE_DERMOCOSMETIQUE',
      label: 'Cosmétique et maquillage (dermocosmétique)',
      icon: '💄',
      subcategories: [
        'Fonds de teint, mascaras, rouges à lèvres',
        'Produits hypoallergéniques pour peaux sensibles'
      ]
    },
    {
      key: 'PRODUITS_TROUBLES_SPECIFIQUES',
      label: 'Produits pour troubles spécifiques',
      icon: '🧬',
      subcategories: [
        'Soins anti-acné, anti-vergetures',
        'Produits anti-chute de cheveux',
        'Solutions pour peaux atopiques, psoriasis'
      ]
    }
  ];
  
  // Fonction utilitaire pour obtenir les informations d'une catégorie
  export const getCategoryInfo = (category) => {
    return PRODUCT_CATEGORIES.find(cat => cat.key === category);
  };
  
  // Fonction utilitaire pour obtenir le label d'une catégorie
  export const getCategoryLabel = (category) => {
    const info = getCategoryInfo(category);
    return info ? info.label : category;
  };
  
  // Fonction utilitaire pour obtenir l'icône d'une catégorie
  export const getCategoryIcon = (category) => {
    const info = getCategoryInfo(category);
    return info ? info.icon : '📦';
  };
  
  // Fonction utilitaire pour obtenir les sous-catégories d'une catégorie
  export const getSubcategories = (category) => {
    const info = getCategoryInfo(category);
    return info ? info.subcategories : [];
  };